{
  "version": 1,
  "asset_id": "8e742d06-bc1f-4f22-8d70-6c4b79bef5a9",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/8e742d06-bc1f-4f22-8d70-6c4b79bef5a9/demo-competitors.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/8e742d06-bc1f-4f22-8d70-6c4b79bef5a9/demo-competitors.webp",
  "original_filename": "demo-competitors.webp",
  "size": 114926,
  "content_type": "image/webp",
  "created_at": "2026-10-14T19:14:13Z"
}
